import React, { memo } from "react";
import { Trans, useTranslation } from "react-i18next";
import { useAppSelector } from "../../store/hooks/hooks";
import Result from "../../components/common/Result";

const ResultsSection: React.FC = () => {
	const calculator = useAppSelector(state => state.hydratesCalculator);
	const result = calculator?.result;
	const { t } = useTranslation();

	return (
		<fieldset className="hydrates__result-block round-corner-container">
			<legend>{t('results_title')}</legend>
			<div className="hydrates__results">
				<div className="result-row">
					<Result
						id={result.id}
						label={
							<Trans
								ns="hydrates"
								i18nKey={t(`result_labels.${result.id}`)}
								components={{
									sub: <sub />,
									sup: <sup />,
								}}
							/>
						}
						unit={<Trans
							ns="hydrates"
							i18nKey={t(`measurement_units.temperature.celsius`)}
							components={{
								sub: <sub />,
								sup: <sup />,
							}}
						/>}
						value={result.value?.toString()}
						key={result.id}
					/>
				</div>
			</div>
		</fieldset>
	);
};

export default memo(ResultsSection);
